import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/User/Login';
import Register from './components/User/Register';
import UserDashboard from './components/Dashboard/UserDashboard';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import Profile from './components/User/Profile';
import Time from './components/Time/TimeRegistration';
import PrivateRoute from './components/Common/PrivateRoute';
import PublicRoute from './components/Common/PublicRoute';
import Navbar from './components/Common/Navbar';
import Users from './components/User/ListUsers';
import TimeEntriesAdmin from './pages/TimeEntriesAdminPage';
import { AuthContext } from './AuthContext';

function App() {
  const { userRole } = useContext(AuthContext);
  return (
    <Router>
	<Navbar />
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute role="admin">
              <Users />
            </PrivateRoute>
          }
        />
		<>
            {userRole === 'admin' ? (
              <Route path="/dashboard" element={<PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>} />
            ) : (
              <Route path="/dashboard" element={<PrivateRoute role="user"><UserDashboard /></PrivateRoute>} />
            )}
        </>
		<Route
          path="/profile"
          element={
            <PrivateRoute role={['admin', 'user']}>
              <Profile />
            </PrivateRoute>
          }
        />
		<Route
          path="/time"
          element={
            <PrivateRoute role={['admin', 'user']}>
              <Time />
            </PrivateRoute>
          }
        />
        <Route
          path="/timeregadmin"
          element={
            <PrivateRoute role={['admin']}>
              <TimeEntriesAdmin />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
